import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_cancel_order_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { order_id: number, order_notes?: string, order_type_id: number, order_class_id: number, order_status_id: number, validate?: boolean }): Promise<{ success?: boolean, messages?: any[], error?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.order_type_id)) {
      $missingRequiredInParams.push('\'order_type_id\'');
    }
    if (isNil($inParams.order_class_id)) {
      $missingRequiredInParams.push('\'order_class_id\'');
    }
    if (isNil($inParams.order_status_id)) {
      $missingRequiredInParams.push('\'order_status_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

